import React from 'react';
import * as Tools from '../../helpers/Tools';
import { withRouter } from "react-router-dom";
import MiniSpinner from "../common/MiniSpinner";
import { Divider, Typography } from "../ecosystem";
import ProxyXBtn from "./home/ProxyXBtn";

const ActiveListProxy = ({
    expiresOn,
    name,
    message,
    circleBtn,
    isWaiting
}) => {

    const spinnerForPending = (
        <div className='overlay-loading-container'>
            <div className='align-self-center'>
                <MiniSpinner />
            </div>
        </div>
    );

    return (<div className="active-list-proxy">
        {isWaiting && spinnerForPending}
        <div className="active-list-proxy__heading">
            <div className="active-list-proxy__member">
                <div className="active-list-proxy__name">
                    <Typography
                        type="body-02"
                        bold
                        color="$color-primary-a2"
                    >
                        {name}
                    </Typography>
                </div>
                {expiresOn &&
                    <div className="active-list-proxy__expire-date">
                        <Typography
                            type="meta-01"
                            color="$color-secondary-a2"
                        >
                            Expires: {Tools.dateStringFormat(expiresOn, 'MM/DD/YYYY')}
                        </Typography>
                    </div>
                }
            </div>
            {circleBtn &&
                <div className="active-list-proxy__button">
                    <ProxyXBtn
                        label={circleBtn.label}
                        onClick={circleBtn.onClick}
                        tooltipId={circleBtn.tooltipId}
                    />
                </div>
            }
        </div>
        {message && 
            <div className="active-list-proxy__message">
                {message}
            </div>
        }
        <Divider
            mLeft="none"
            mRight="none"
        />
    </div>);
}

export default withRouter(ActiveListProxy);
